import PropTypes from 'prop-types';
import Component from '@ux/component';

/**
 * Base class that contains the rating, count and onClick of a Star
 *
 * @class Base
 * @constructor
 * @extends React.Component
 */
export default class Base extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      rating: props.rating,
      count: props.count
    };
  }

  /**
  * Sets state with rating star index.
  * @param {Function} func callback.
  * @param {number} star Selected stars.
  * @returns {Function} generateOnClick event
  * @private
  */
  generateOnClick(func, star) {
    return () => {
      this.setState({ rating: star });
      func(star);
    };
  }

  /**
   * Returns string with value of text rating.
   *
   * @returns {string} Rating text.
   * @private
   */
  renderText() {
    const { rating, count } = this.state;
    return this.props.text ? `${ rating } / ${ count }` : '';
  }
}

Base.propTypes = {
  /** Flag stating whether an <h1> tag should be rendered indicating the current rating.*/
  text: PropTypes.bool,
  /** The current star rating to be rendered*/
  rating: PropTypes.number,
  /** Total number of stars*/
  count: PropTypes.number
};

Base.defaultProps = {
  text: true,
  rating: 3,
  count: 5
};
